import { combineReducers } from '@ynap/reducer-utils'
import * as reducers from './reducers/index'

const creditsReducer = combineReducers(reducers)

export default creditsReducer
